import { ATTACHMENTS } from '@/config/attachments.constants';

// Splits newly-chosen files into the ones we keep and one rejection reason per file.
export const REJECTION = Object.freeze({
  notPdf: 'SHIPMENT_ATTACHMENT_ERROR_NOT_PDF',
  tooLarge: 'SHIPMENT_ATTACHMENT_ERROR_TOO_LARGE',
  duplicate: 'SHIPMENT_ATTACHMENT_ERROR_DUPLICATE',
  tooMany: 'SHIPMENT_ATTACHMENT_ERROR_TOO_MANY',
});

const isPdf = (file) =>
  file.type === ATTACHMENTS.accept || file.name.toLowerCase().endsWith(ATTACHMENTS.extension);

// maxFiles defaults to the flat cap; edit passes a lower one when existing.
export const pickAttachments = (existing, incoming, maxFiles = ATTACHMENTS.maxFiles) => {
  const accepted = [...existing];
  const rejected = [];

  for (const file of incoming) {
    if (!isPdf(file)) {
      rejected.push({ name: file.name, reason: REJECTION.notPdf });
      continue;
    }
    if (file.size > ATTACHMENTS.maxBytes) {
      rejected.push({ name: file.name, reason: REJECTION.tooLarge });
      continue;
    }
    // Same name AND size — re-picking the identical file shouldn't add it twice.
    if (accepted.some((kept) => kept.name === file.name && kept.size === file.size)) {
      rejected.push({ name: file.name, reason: REJECTION.duplicate });
      continue;
    }
    if (accepted.length >= maxFiles) {
      rejected.push({ name: file.name, reason: REJECTION.tooMany });
      continue;
    }
    accepted.push(file);
  }

  return { accepted, rejected };
};
